export class WorkflowDefination {
    public id: number;
    public flowId: number;
    public level: number;
    public stage: number;
    public approval_type: string;
    public approval_value: string;
    public timeout: number;
    public timeout_action: string;
    public approval_criteria: string;
    public stage_default_criteria: string;
    public stage_criteria_sql: string;
    public stage_criteria_code: string;
    public created_dt: Date;
    public created_by: string;
    public update_dt: Date;
    public updated_by: string;

    constructor() {
        this.id = null;
        this.flowId = null;
        this.level = null;
        this.stage = null;
        this.stage_criteria_code = '';
        this.approval_criteria = '';
        this.approval_type = '';
        this.approval_value = '';
        this.timeout = null;
        this.timeout_action = '';
        this.stage_default_criteria = '';
        this.stage_criteria_sql = '';
        this.stage_criteria_code = '';
        this.created_dt = null;
        this.created_by = '';
        this.update_dt = null;
        this.updated_by = '';
    }
}
